import moment from "moment";

export const getVisitDuration = (visitData): number => {
    if (visitData.start_time) {
        // NOTE: In older versions of KarunaHOME that didn't have motion_time,
        // the total time from start to end is used to calculate the approximate duration.
        return (visitData.motion_time && visitData.motion_time > 0) ? visitData.motion_time * 1000 : 0;
    }
    return 0;
};

export const getCompletedVisitDuration = (visitData) => {
    if (visitData.start_time && visitData.end_time) {
        let endTime = moment(visitData.end_time);
        let startTime = moment(visitData.start_time);
        return moment.duration(endTime.diff(startTime)).asMilliseconds();
    }

    return 0;
};

export const getRoms = (
    roms,
    visitData
) => {
};
